<template>
    <div class="survey-range-container">
        <p v-if="field.name">{{field.name}}</p>
        <div class="form-container">
            <div class="form-container__field">
                <md-field>
                    <label>{{field.placeholder.split(',')[0]}}</label>
                    <md-input v-model="model[0]" @blur="onBlur()"
                              v-on:change="onModelChange"></md-input>
                </md-field>
            </div>
            <div class="form-container__divider">- 0 -</div>
            <div class="form-container__field">
                <md-field>
                    <label>{{field.placeholder.split(',')[1]}}</label>
                    <md-input v-model="model[1]" @blur="onBlur()"
                              v-on:change="onModelChange"></md-input>
                </md-field>
            </div>
        </div>
        <div class="children" v-if="model[0] && model[1]">
            <div v-for="(child, index) in field.children" v-bind:key="index">
                <survey-field v-bind:key="index" v-bind:field="child"></survey-field>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-param-reassign */

export default {
  name: 'SurveyRange',
  data() {
    return {
      model: {
        0: null,
        1: null,
      },
      blured: false,
    };
  },
  methods: {
    onModelChange() {
      if (!this.model[0] && !this.model[1]) {
        this.$emit('modelChange', {
          fieldId: this.field.id,
        });
        this.field.value = undefined;
        this.clearModel();
        this.clearChildren(this.field);
      } else {
        this.$emit('modelChange', {
          newVal: JSON.stringify(this.model),
          oldVal: JSON.stringify(this.field.value),
          fieldId: this.field.id,
        });
        this.field.value = JSON.stringify(this.model);
      }
      this.$emit('nodeChange', this.field);
    },
    onBlur() {
      this.blured = true;
    },
    clearModel() {
      this.model = {
        0: null,
        1: null,
      };
    },
    clearChildren(node) {
      node.children.forEach((child) => {
        if (child.type === 'GROUP_RADIO') {
          child.value = undefined;
          this.clearChildren(child);
        } else if (child.type === 'RADIO') {
          delete child.value;
          if (child.children) {
            this.clearChildren(child);
          }
        } else {
          child.value = undefined;
        }
      });
    },
  },
  props: ['field'],
  created() {
    if (this.field.value) {
      this.model = JSON.parse(this.field.value);
    }
  },
};
</script>

<style src="./SurveyRange.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyRange/SurveyRange.vue